import {Injectable} from '@angular/core';
import {PersonenstammDaten, StammdatenNatuerlichePerson} from '@nachdigal';
import {AbstractMapper} from '../../abstract.mapper';

@Injectable()
export class PersonenstammdatenMapperService extends AbstractMapper<StammdatenNatuerlichePerson, PersonenstammDaten> {

  protected mapInternal(source: StammdatenNatuerlichePerson): PersonenstammDaten {
    return {
      vorname: source.vorname,
      nachname: source.nachname,
      namensvorsatz: source.namensvorsatz,
      namenszusatz: source.namenszusatz,
      titel: source.titel
    };
  }
}
